export default defineAppConfig({
  ui: {
    colors: {
      primary: 'amber',
      secondary: 'emerald',
      neutral: 'zinc',
    },
  },
})
